import { useEffect, useState } from "react";
import { shopsAPI } from "../services/api";

/** The shop's currency code — "TND" until the shop has loaded. */
const useShopCurrency = () => {
  const [currency, setCurrency] = useState("TND");

  useEffect(() => {
    let cancelled = false;

    shopsAPI
      .current()
      .then(({ data }) => {
        if (!cancelled && data.shop?.currency) setCurrency(data.shop.currency);
      })
      .catch(() => {});

    return () => {
      cancelled = true;
    };
  }, []);

  return currency;
};

export default useShopCurrency;
